import { Entry } from '../Entry';
import { Position } from '../generic/Position';
import { GeocoderEntry } from '../search/GeocoderEntry';

export enum Compass {
  North = 'N',
  NorthWest = 'NW',
  NorthEast = 'NE',
  West = 'W',
  East = 'E',
  South = 'S',
  SouthWest = 'SW',
  SouthEast = 'SE'
}

export enum NavigationCommand {
  None = 'blank',
  Start = 'Start',
  Forward = 'ArrowForward',
  Right = 'ArrowRight',
  Left = 'ArrowLeft',
  HalfRight = 'ArrowHalfRight',
  HalfLeft = 'ArrowHalfLeft',
  CircleOut = 'CircleOut',
  CircleIn = 'CircleIn',
  End = 'End'
}

export enum RouteRequestMode {
  Start,
  Station1,
  Station2,
  Station3,
  End
}

export interface WayPoint extends Position {
  type: 'WayPoint';
  nextDistance: number;
  nextDuration: number;
  directionText: string;
  trackSectionText: string;
  description: string;
  compass: Compass;
  navigationCommand: NavigationCommand;
  position: ym.provider.LatLngLiteral;
}

export interface RouteGeocoderEntry {
  type: 'RouteGeocoder';
  mode: RouteRequestMode;
  entries: GeocoderEntry[];
}

export interface RouteEntry extends Entry {
  type: 'Route';
  distance?: number;
  duration?: number;
  polyline?: Array<[number, number]>;
  waypoints?: WayPoint[];
  geocoding?: RouteGeocoderEntry[];
  error?: string;
  fitBounds: boolean;
  position: ym.provider.LatLngLiteral;
}
